import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import './lib/axiosSetup';
import App from './App';
import theme from './theme';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   
        <ChakraProvider theme={theme}>
            <App />
        </ChakraProvider>
   
);
